<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-department-employees-provider
            v-slot="departmentEmployeeRelations"
            :department-id="departmentId"
        >
            <div class="animated fadeIn">
                <kgr-department-employees-relations-form
                    :department-employee-relations="departmentEmployeeRelations.data"
                    :department-id="departmentId"
                    :club-id="clubId"
                    :error="error"
                    :is-creatable="isCreatable"
                    @updated="onUpdate(departmentEmployeeRelations.reload)"
                />
            </div>
        </kgr-department-employees-provider>
    </kgr-form-scaffold>
</template>

<script>
import DepartmentEmployeesProvider from '../../components/data-provider/DepartmentEmployeesProvider';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrDepartmentEmployeesRelationsForm from '../../components/departments/DepartmentEmployeeRelationsForm';

export default {
    components: {
        KgrDepartmentEmployeesRelationsForm,
        'kgr-department-employees-provider': DepartmentEmployeesProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        departmentId: {
            type: Number,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onUpdate(reload) {
            reload();
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
